

//GetAll
export const GET_STATE = "/api/State/GetAll";

//GetAll Occupation
export const GET_OCCUPATION = "/api/Occupation/GetAll";

//GetAll Related_Person_Type
export const GET_RELATEDPERSONTYPE = "/api/RelatedPersonType/GetAll";

//GetAll Education
export const GET_EDUCATION = "/api/Education/GetAll";

//GetAll OccupationDeatils
export const GET_OCCUPATIONDETAILS = "/api/OccupationDetails/GetAll";

//GetAll AssetDetails
export const GET_ASSETDETAILS = "/api/AssetDetails/GetAll";

//GetAll OtherBankAccounts
export const GET_OTHERBANKACCOUNTS = "/api/OtherBankAccounts/GetAll";

//GetAll AccountType
export const GET_ACCOUNTTYPE = "/api/AccountType/GetAll";

//GetAll EntityType
export const GET_ENTITYTYPE = "/api/EntityType/GetAll";

//GetAll Location
export const GET_LOCATION = "/api/Location/GetAll";

// GetByLocationId Branch
export const GET_BRANCH = "/api/Branch";

//GetAll POI
export const GET_POI = "/api/POI/GetAll";

//GetAll Reason To Become a Customer
export const GET_REASON_TO_BECOME_CUSTOMER = "/api/Registration/GetCustomerReasonList"

//Post-Get Otp
export const POST_GETOTP = "/api/OTP/GetOTP";

//Post-Verify Otp
export const POST_VERIFYOTP = "/api/OTP/VerifyOTP";

//Post-Branch
export const POST_BRANCH = "/api/Branch/GetAll";

//Post-Registration
export const POST_REGISTRATION = "/api/Registration/Registration";

//Post-UpdatePersonalDetails
export const POST_UPDATEPERSONALDETAILS = "/api/Registration/UpdatePersonalDetails";

//Post-RegistrationPOI
export const POST_REGISTRATIONPOI = "/api/Registration/RegistrationPOI";

//Post-UpdateFamilyDetails
export const POST_FAMILYDETAILS = "/api/Registration/UpdateFamilyDetails";

//Post-UpdateDetailOfRelatedPerson
export const POST_RELATEDPERSONDETAILS = "/api/Registration/UpdateDetailOfRelatedPerson";

//Post-UpdateForm60
export const POST_FORM60 = "/api/Registration/UpdateFormNo60";

//Post-UpdateAdditionalDetails
export const POST_ADDITIONALDETAILS = "/api/Registration/UpdateAdditionalDetails";

//Post-UpdateTechnoProducts
export const POST_TECHNOPRODUCTS = "/api/Registration/UpdateTechnoProducts";

//Post-UpdateNominationDetails
export const POST_NOMINATIONDETAILS = "/api/Registration/UpdateNominationDetails";

//Post-SubmitAccount
export const POST_SUBMITACCOUNT = "/api/Registration/SubmitAccount";

//Get-AllCustomerAccountList
export const POST_GETALLCUSTOMERACCOUNTLIST = "/api/Registration/GetAllCustomerAccountList";

//Get-AllBranchLoginCustomerList
export const POST_GETALLBRANCHLOGINCUSTOMERLIST = "/api/Registration/GetAllBranchLoginCustomerList";

//Get-AllBranchLoginCustomerList via reference no
export const POST_GETREGISTRATIONDETAILSBYREFNO = "/api/Registration/GetRegistrationDetailsByRefNo";


//Delete-Account
export const POST_DELETECUSTOMERACCOUNT = "/api/Registration/DeleteCustomerAccount";

//Delete-Account Holder
export const POST_DELETECUSTOMERACCOUNTHOLDER = "/api/Registration/DeleteCustomerAccountHolder";

//Add-Account Holder
export const POST_ADDCUSTOMERACCOUNTHOLDER = "/api/Registration/AddApplicantHolder";

//Post-CreateNewAccount
export const POST_CREATENEWACCOUNT = "/api/Registration/CreateNewAccount";

//Post-GetCustomerAccountDetails
export const POST_GETCUSTOMERACCOUNTHOLDERLIST = "/api/Registration/GetCustomerAccountHolderList";

//Post-GetOtherHolderDetails
export const POST_GETOTHERHOLDERSDETAILS = "/api/Registration/GetOtherHolderDetails";

//Post-UpdateAccountOperation
export const POST_UPDATEACCOUNTOPERATION = "/api/Registration/UpdateAccountOperation";

//Post-GetCustomerAdditionalDetails
export const POST_GETCUSTOMERADDITIONALDETAILS = "/api/Registration/GetCustomerAdditionalDetails";

//Post-GetCustomerNominationDetails
export const POST_GETCUSTOMERNOMINEEDETAILS = "/api/Registration/GetCustomerNominationDetails";

//Post-GetCustomerTechnoProductsDetails
export const POST_GETCUSTOMERTECHNOPRODUCTDETAILS = "/api/Registration/GetCustomerTechnoProductsDetails";

//Post-GetCustomerAccountOperationsDetails
export const POST_GETACCOUNTOPERATIONSDETAILS = "/api/Registration/GetCustomerAccountOperationsDetails";

//Post-CheckCustomerExists
export const POST_CHECKCUSTOMEREXISTS = "/api/Registration/CheckCustomerExists";

//Post-UpdateAccountHolderStatus
export const POST_UPDATEACCOUNTHOLDERSSTATUS = "/api/Registration/UpdateAccountHolderStatus";

//Post-GetFirstAccountHolderDetails
export const POST_GETFIRSTACCOUNTHOLDERDETAILS = "/api/Registration/GetFirstAccountHolderDetails";

//Post-GetFDDetails
export const POST_GETFDDETAILS = "/api/Registration/GetFDDetails";

//Post-UpdateFDDetails
export const POST_FDDETAILS = "/api/Registration/UpdateFDDetails";

//Post-GetRDDetails
export const POST_GETRDDETAILS = "/api/Registration/GetRDDetails";

//Post-UpdateRDDetails
export const POST_RDDETAILS = "/api/Registration/UpdateRDDetails";

//Post-DeletePOI
export const POST_DELETEPOI = "/api/Registration/DeleteCustomerPOI";

//Post-GETCustomerDataByCustomerId
export const POST_GETCUSTOMERDATABYCUSTOMERID = "/api/Registration/GetCustomerDataByCustomerId";
 
//Get-AllBranchLoginCustomerList
export const POST_CHECKBRANCHLOGIN = "/api/BranchLogin/CheckLogin";

export const POST_GETCUSTOMERPROFILEDETAILS = "/api/Registration/GetCustomerProfileDetails";


//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";

//Mails
export const GET_INBOX_MAILS = "/inboxmails";
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail";
export const DELETE_INBOX_MAIL = "/delete/inboxmail";

//starred mail
export const GET_STARRED_MAILS = "/starredmails";

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails";

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails";

//Send mail
export const GET_SENT_MAILS = "/sentmails";

//Trash mail
export const GET_TRASH_MAILS = "/trashmails";

//CALENDER
export const GET_EVENTS = "/events";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

//ORDERS
export const GET_ORDERS = "/orders";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

//CART DATA
export const GET_CART_DATA = "/cart";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//CRYPTO
export const GET_WALLET = "/wallet";
export const GET_CRYPTO_ORDERS = "/crypto/orders";

//INVOICES
export const GET_INVOICES = "/invoices";
export const GET_INVOICE_DETAIL = "/invoice";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/project";
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

//TASKS
export const GET_TASKS = "/tasks";

//CONTACTS
export const GET_USERS = "/users";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

export const TOP_SELLING_DATA = "/top-selling-data";

export const GET_EARNING_DATA = "/earning-charts-data";

export const GET_PRODUCT_COMMENTS = "/comments-product";

export const ON_LIKNE_COMMENT = "/comments-product-action";

export const ON_ADD_REPLY = "/comments-product-add-reply";

export const ON_ADD_COMMENT = "/comments-product-add-comment";
